window.MonnifyPaymentData = window.payload || {};
export default window.MonnifyPaymentData;